const
  calendarDefaultState = {
    orderLength: [],
    ticketObject: {
      date: "",
      time: ""
    }
  },
  calendarReducer = (state = calendarDefaultState, action) => {
    switch (action.type) {
      case 'ORDERLENGTH':
        return Object.assign({}, state, { orderLength: action.orderLength });

      case 'TICKETOBJECT':
        return Object.assign({}, state, { ticketObject: action.ticketObject })

      case 'HOLIDAYS':
        return Object.assign({}, state, { holidays: action.holidays })

      default:
        return state;
    }
  };

export { calendarDefaultState, calendarReducer };
